/**
 * Top-level app route paths (funnel, marketing, legal). Use these instead of
 * hardcoding path strings in `navigate({ to })`, `redirect`, `href()` and route
 * definitions. Webapp tab routes live in `webapp-routes.ts` (`WebappRoutes`).
 */
export const AppRoutes = {
  HOME: "/",
  QUIZ: "/quiz",
  CHECKOUT: "/checkout",
  UPSELL: "/upsell",
  ADDITIONAL_OFFERS: "/additional-offers",
  SIGN_IN: "/signin",
  CREATE_ACCOUNT: "/create-account",
  ACTIVATE: "/activate",
  SUCCESS: "/success",
  REDIRECT: "/redirect",
  PRIVACY: "/privacy",
  TERMS: "/terms",
  COOKIES: "/cookies",
} as const

export type AppRoute = (typeof AppRoutes)[keyof typeof AppRoutes]
